{
  "infoOptions": {
    "statistics": {
      "statistics": "Statistics",
      "avgPrice": "Avg. price",
      "openPrice": "Open",
      "closePrice": "Close",
      "beforeClose": "Prev. close",
      "lastTrade": "Last trade",
      "maxDay": "High of the day",
      "minDay": "Low of the day",
      "openInterest": "Open interest",
      "implVolatility": "Impl. vol.",
      "volumePerDay": "Daily volume"
    },
    "greek": {
      "greek": "Greeks",
      "delta": "Delta",
      "theta": "Theta",
      "gamma": "Gamma",
      "vega": "Vega"
    },
    "description": "The displayed options statistics represent indicative prices from our market data provider. Execution prices for market orders may differ from the displayed indicative quotes.",
    "notHaveOption": "Select an option to view information"
  }
}
